import React from 'react';
import { FiMic, FiX } from 'react-icons/fi';

const ListeningOverlay = ({ isRecording, transcript, onStop }) => {
    if (!isRecording) return null;

    return (
        <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[9999] animate-in fade-in slide-in-from-bottom-4 duration-200">
            <div className="bg-white rounded-xl shadow-lg border border-red-100 px-4 py-2.5 flex items-center gap-3 min-w-[280px]">
                <div className="relative shrink-0">
                    <div className="absolute inset-0 bg-red-400 rounded-full animate-ping opacity-50"></div>
                    <div className="relative bg-red-500 rounded-full p-1.5 text-white">
                        <FiMic size={14} />
                    </div>
                </div>

                <div className="flex-1 min-w-0">
                    <p className="text-xs font-semibold text-red-600">Escuchando...</p>
                    <p className="text-xs text-gray-500 truncate">
                        {transcript || "Di algo..."}
                    </p>
                </div>

                <button
                    onClick={onStop}
                    className="shrink-0 p-1.5 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors"
                    title="Detener"
                >
                    <FiX size={14} />
                </button>
            </div>
        </div>
    );
};

export default ListeningOverlay;
